
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProjectSettingsResource,
  ProjectSettingsUpdateRequest,
} from '../models';
import {
    ProjectSettingsResourceFromJSON,
    ProjectSettingsResourceToJSON,
    ProjectSettingsUpdateRequestFromJSON,
    ProjectSettingsUpdateRequestToJSON,
} from '../models';

export interface GetProjectSettingsRequest {
    companyId: string;
}

export interface UpdateProjectSettingsRequest {
    companyId: string;
    projectSettingsUpdateRequest: ProjectSettingsUpdateRequest;
}

/**
 * 
 */
export class ClientCompanyProjectSettingsApi extends runtime.BaseAPI {

    /**
          */
    async getProjectSettingsRaw(requestParameters: GetProjectSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectSettingsResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getProjectSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectSettingsResource>({
            path: `/client-settings/api/{companyId}/project`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectSettingsResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getProjectSettings(requestParameters: GetProjectSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectSettingsResource> {
        const response = await this.getProjectSettingsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async updateProjectSettingsRaw(requestParameters: UpdateProjectSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectSettingsResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateProjectSettings().'
            );
        }

        if (requestParameters['projectSettingsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'projectSettingsUpdateRequest',
                'Required parameter "projectSettingsUpdateRequest" was null or undefined when calling updateProjectSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ProjectSettingsResource>({
            path: `/client-settings/api/{companyId}/project`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectSettingsUpdateRequestToJSON(requestParameters['projectSettingsUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=ProjectSettingsResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async updateProjectSettings(requestParameters: UpdateProjectSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectSettingsResource> {
        const response = await this.updateProjectSettingsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
